import { State } from './state';
import {
	getModal,
	getContext,
	getModalFields,
	getActiveContext,
	getConditionRows,
	getRowElements,
} from './dom';
import { updateConditionRow, resetModalFields } from './condition-row';
import { shouldHookNameBeEditable } from './ui';
import { SELECTORS } from './selectors';

const $ = jQuery;

/**
 * Open modal and hydrate data
 * @param postId
 * @param ajax
 */
export function openModal(postId, ajax = {}) {
	State.currentPostId = postId;

	const $modal = getModal();

	resetModalFields();

	const data = State.getCurrent();
	const sectionKey = Object.keys(data)[0] || null;
	const section = sectionKey ? data[sectionKey] : null;

	const $context = getContext(sectionKey);
	const $fields = getModalFields($context);

	// Set context selector value
	if (sectionKey) {
		$(SELECTORS.contextSelect).val(sectionKey);
	}

	if (section) {
		$fields.hook.val(section.hook || '');
		$fields.hookName.val(section.hook_name || '');
		$fields.priority.val(section.priority ?? 10);

		shouldHookNameBeEditable($modal);

		if (Array.isArray(section.conditions)) {
			section.conditions.forEach((condition, index) => {
				let $row;

				if (index === 0) {
					$row = getConditionRows($context).first();
				} else {
					$row = getConditionRows($context)
						.first()
						.clone(false, false);

					const el = getRowElements($row);

					$row.find('.select2').remove();
					el.type.val('');
					el.ids.empty().off();
					el.idsWrap.hide();

					$row.insertAfter(getConditionRows($context).last());
				}

				$row.attr('data-index', index);

				// hydrate row
				const el = getRowElements($row);
				el.type.val(condition.target);

				updateConditionRow($row, condition, ajax);
			});
		}
	}

	$context.addClass('active');

	$modal.addClass('is-open');
	$('body').addClass('snap-blocks-modal-open');
}

/**
 * Close modal
 */
export function closeModal() {
	const $modal = getModal();
	resetModalFields();
	State.reset();
	$modal.removeClass('is-open');
	$('body').removeClass('snap-blocks-modal-open');
}

/**
 * Collect data from modal for saving
 */
export function collectModalData() {
	const $modal = getModal();
	const $activeContext = getActiveContext($modal);
	const fields = getModalFields($activeContext);

	if (!$activeContext.length) {
		return null;
	}

	const section = $activeContext.data('id');
	const conditions = [];

	getConditionRows($activeContext).each(function () {
		const el = getRowElements($(this));
		const target = el.type.val();

		if (!target) {
			return;
		}

		const object_type = el.type.find('option:selected').data('object-type');

		const selected = el.ids.val() || [];
		const ids = selected.map((id) => parseInt(id, 10)).filter(Boolean);

		conditions.push({
			object_type,
			target,
			ids,
		});
	});

	return {
		post_id: State.currentPostId,
		section,
		hook: fields.hook.val(),
		hook_name: fields.hookName.val(),
		priority: fields.priority.val(),
		skip_conditions: fields.skipConditions.val(),
		conditions,
	};
}
